import moment from "moment/moment";
import { MissionEnums, MissionEnumsLists } from "./constants";
import { formatText } from "./helpers";


export default class CommentBuilder {

  constructor(t, mission, journalLine) {
    this._t = t;
    this._mission = mission;
    this._journal = journalLine;
    this._lines = [];
  }

  build() {
    const t = this._t;
    const mission = this._mission;
    const details = mission.details;
    const target = mission.target;
    const actors = mission.actors;
    const salvage = mission.salvageTasks;
    const journal = this._journal;

    if (!!mission?.request?.name) {
      this.add(t("exportFormats:so01:request") , mission.request.name);
    }

    switch (target.type) {
      case MissionEnums.TargetType.Car:
        this.add(t("exportFormats:so01:vehicle"), formatText(" ", target.carDetails.make, target.carDetails.model));
        this.add(t("exportFormats:so01:registration"), target.carDetails.registration);
        break;

      case MissionEnums.TargetType.Boat:
        this.add(t("exportFormats:so01:vehicle"), formatText(" ", target.boatDetails.make, target.boatDetails.model));
        this.add(t("exportFormats:so01:registration"), target.boatDetails.registration);
        break;
    }

    this.add(t("exportFormats:so01:missionType"), t(`mission:enums:type:${MissionEnumsLists.Type[details.type]}`));

    if (details.type === MissionEnums.Type.Salvage && !!details.cause?.name) {
      this.add(t("exportFormats:so01:missionCause"), details.cause?.name);
    }

    this.add(t("exportFormats:so01:missionCreated"), moment(mission.created).format("YYYY-MM-DD HH:mm"));
    this.add(t("exportFormats:so01:missionRef"), `${mission.number}-${journal.orderNumber}-${journal.exportNumber}`);
    this.add(t("exportFormats:so01:requirer"), actors.ownerIsNotRequester ? actors.requester?.name : actors.owner?.name);
    this.add(t("exportFormats:so01:contractRef"), actors.contract.reference);

    if (salvage.length !== 0) {
      const route = salvage[0]?.route;
      const waypoints = route.waypoints;

      if (waypoints.length !== 0) {
        const location = waypoints[0];
        this.add(t("exportFormats:so01:missionLocation"), formatText(", ", location?.address || location?.title, formatText(" ", location?.postCode, location?.place)));
      }

      if (waypoints.length > 1) {
        const location = waypoints.findLast(t => !!t.address || !!t.title);
        if (!!location && waypoints.findLastIndex(t => !!t.address || !!t.title) > 0) {
          this.add(t("exportFormats:so01:missionTransportTo"), formatText(", ", location.address || location.title, formatText(" ", location.postCode, location.place)));
        }
      }
    }

    this.add(t("exportFormats:so01:invoiceComment"), journal.comment);
    this.add(t("exportFormats:so01:invoiceReference"), journal.Reference);

    if (journal.hasVatTransfer) {
      this.add(t("exportFormats:so01:notice"), t("exportFormats:so01:hasVatTransfer"));
    }

    return this._lines;
  }

  add(field, value) {
    if (!!field && !!value) {
      this._lines.push(`${field}: ${value}`);
    }
  }

}